import { TrendChart } from "@/components/TrendChart";
import { Leaderboard } from "@/components/Leaderboard";
import { TopBottomYO } from "@/components/TopBottomYO";

const FULL = new Set(["leaderboard", "table"]);

// Render blok sesuai urutan dari Pengaturan; blok setengah lebar berurutan digabung dalam grid 2 kolom.
export const RingkasanCharts = ({ data, showLb, table }) => {
  const charts = Object.fromEntries([data.trend, ...(data.charts || [])].filter(Boolean).map((c) => [c.id, c]));
  const render = (b) => {
    if (b === "leaderboard") return showLb ? <Leaderboard key={b} /> : null;
    if (b === "table") return <div key={b}>{table}</div>;
    if (b === "topbottom") return <TopBottomYO key={b} rows={data.officers} n={5} />;
    return charts[b] ? <div key={b} data-testid={`ringkasan-chart-${b}`}><TrendChart trend={charts[b]} /></div> : null;
  };
  const groups = [];
  (data.layout || []).forEach((b) => {
    const last = groups[groups.length - 1];
    if (FULL.has(b)) groups.push({ full: true, items: [b] });
    else if (last && !last.full) last.items.push(b);
    else groups.push({ full: false, items: [b] });
  });
  return (
    <div data-testid="ringkasan-charts" className="space-y-6">
      {groups.map((g, i) => (g.full ? render(g.items[0])
        : <div key={i} className="grid gap-6 xl:grid-cols-2">{g.items.map(render)}</div>))}
    </div>
  );
};
